<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    persistent
  >
    <v-card>
      <v-toolbar
        :color="site_color"
        dark
      >
        <h2 class="font-weight-light">
          {{ popup_name }}
        </h2>
      </v-toolbar>
      <v-row
        v-show="popup_image"
        justify="center"
        class="pa-5"
      >
        <v-img
          :src="popup_image"
          aspect-ratio="1.5"
          max-width="90%"
        />
      </v-row>
      <v-card-text>
        {{ popup_description }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-show="popup_button_flag"
          :color="site_color"
          :href="popup_button_url"
          target="_blank"
        >
          {{ popup_button_name }}
        </v-btn>
        <v-btn
          :color="site_color"
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'PopupModal',
    data: () => ({
      dialog: false,
      popup_id: '',
      popup_name: '',
      popup_description: '',
      popup_image: '',
      popup_button_flag: false,
      popup_button_url: '',
      popup_button_name: '',
      site_color: '',
    }),
    created () {
      // this.site_color = this.$store.state.site_color
      // this.popup_id = this.$store.state.popup_id
      // this.popup_name = this.$store.state.popup_name
      // this.popup_description = this.$store.state.popup_description
      // this.popup_image = this.$store.state.popup_image
    },
    mounted () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_SITE_COLOR') {
          this.site_color = state.site_color
        }
        if (mutation.type === 'SET_POPUP_NAME') {
          this.popup_name = state.popup_name
        }
        if (mutation.type === 'SET_POPUP_DESCRIPTION') {
          this.popup_description = state.popup_description
        }
        if (mutation.type === 'SET_POPUP_IMAGE') {
          this.popup_image = state.popup_image
        }
        if (mutation.type === 'SET_POPUP_BUTTON_FLAG') {
          this.popup_button_flag = state.popup_button_flag
        }
        if (mutation.type === 'SET_POPUP_BUTTON_URL') {
          this.popup_button_url = state.popup_button_url
        }
        if (mutation.type === 'SET_POPUP_BUTTON_NAME') {
          this.popup_button_name = state.popup_button_name
        }
      })
    },
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
      },
    },
  }
</script>
